/**
 * サンプルクラス
 * @constructor
 */
class J_SpTab {
  constructor() {

  }
  /**
   * サンプル
   */
  init() {
    let tabNumber,
      $tabCont = $('.p-top__tabCont'),
      $tabContUl = $('.p-top__tabContUl'),
      $kvInner = $('.m-kv__inner');

    $('.j_SpTab').on('click', (e) => {
      tabNumber = $(e.currentTarget).attr('data-tab-number');
      
      tabAct($tabCont,$tabContUl,$kvInner,tabNumber);
    });

    function tabAct (obj01,obj02,obj03,num01) {
      obj01.attr('id',' ');
      obj01.attr('id','p-top__tabCont--0'+num01);
      obj02.attr('id',' ');
      obj02.attr('id','p-top__tabContUl--0'+num01);
      obj03.attr('id',' ');
      obj03.attr('id','m-kv__inner--0'+num01);
      $('.p-top__tabContBox').hide();
      $('.p-top__tabContBox--0'+num01).show();
    }
  }
};

export default J_SpTab;
